import * as React from 'react';
import PageContainer from "@components/PageContainer";
import PageTitle from "@layout/PageTitle";
import Block from "@layout/Block";
import Font from "@layout/Font";
import './index.scss';
import classnames from 'classnames';
import { debounce } from 'throttle-debounce';
import { screenWidth } from '@utils/ViewPort';

interface Props { }
interface State {
    iframeKey: number;
    iframeHidden: boolean;
}

class Skills extends React.Component<Props, State> {
    private screenWidth:number = screenWidth();

    constructor(props: Props) {
        super(props);
        this.state = {
            iframeKey: 0,
            iframeHidden: false,
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        window.addEventListener('resize', this.onResizeHide);
    }

    componentWillUnmount() {
        this.removeWindowListeners();
    }

    private removeWindowListeners = () => {
        window.removeEventListener('resize', this.onResize);
        window.removeEventListener('resize', this.onResizeHide);
    }

    private onResize = debounce(1000, () => {
        const width = screenWidth();
        if (width === this.screenWidth) {
            return ;
        }

        let { iframeKey } = this.state;
        this.setState({iframeKey: ++iframeKey, iframeHidden: false});
        this.screenWidth = width;
    })

    private onResizeHide = (e: any) => {
        let { iframeHidden } = this.state;
        if (iframeHidden || screenWidth() === this.screenWidth) {
            return ;
        }

        this.setState({iframeHidden: true});
    }

    
    render(): JSX.Element {
        let { iframeKey, iframeHidden } = this.state;
        return (
            <PageContainer>
                <Block indent="10">
                    <PageTitle>
                        Skills Map
                    </PageTitle>
                </Block>
                <Block indent="80">
                    <Font font="secondary">
                        Interactive representation of the gained competencies and skills derived from past jobs
                    </Font>
                </Block>
    
                <div className={classnames('skills', {hidden: iframeHidden})}>
                    <iframe
                        key={iframeKey}
                        src={process.env.PUBLIC_URL + '/skills/skills.html'}
                        frameBorder="0"
                        scrolling="no"
                    />
                </div>
            </PageContainer>
        )
    }
}


export default Skills;


// WEBPACK FOOTER //
// ./src/components/Skills/index.tsx